angular.module("avant.customer_applications.controllers").controller "ApplicationMixinCtrl", [
  "$scope", "$location", "ConfigService", "GoogleTagManagerService", "CustomerApplicationService", "ApplicationService", "ProductService", "$sce", "AvantErrorService", "$filter", "$q", "$timeout", "$window", "HeapService", "CONFIG", "$rootScope", "$modal", "$interval", "$document",
  ($scope, $location, ConfigService, GoogleTagManagerService, CustomerApplicationService, ApplicationService, ProductService, $sce, AvantErrorService, $filter, $q, $timeout, $window, HeapService, CONFIG, $rootScope, $modal, $interval, $document) ->

    REQUESTED_AMOUNT_INCREMENT = 100
    AMOUNT_CHANGE_INTERVAL_TIME = 150

    $scope.requestedAmountIncrement = REQUESTED_AMOUNT_INCREMENT

    $scope.currentYear = (new Date()).getFullYear()
    $scope.submitDisabled = false
    $scope.submittingPage = null
    $scope.maximum_borrow_amount = null #expect integer

    $scope.customer ||= {}
    $scope.customer_application ||= {}
    $scope.customer_consent ||= {}
    $scope.promotions ||= []
    $scope.boolean_gates ||= {}
    $scope.loanAmountUpdatedBySlider = false

    $scope.inputPressEnter = (event, ivar, field) ->
      event?.preventDefault()
      $scope.$broadcast "input_keypress:enter",
        ivar: ivar
        field: field

    $scope.setChatGroup = (group) ->
      if olark? && group?
        olark 'api.chat.setOperatorGroup',
          group: group

    $scope.$on "hard_reload_page", (event, data) ->
      $window.location.replace ConfigService.viewBaseUrl(ApplicationService.target_application_id())

    $scope.is_variant = (type, variant) ->
      $scope.config && $scope.config.variant && ($scope.config.variant[type] is variant)

    $scope.$on "customer_application:data", (event, data) ->
      if data && data.customer_application && data.customer_application.uuid

        HeapService.setCustomerApplicationData {
          "customer_application_id": data.customer_application.id,
          "lead_id": data.customer_application.lead_id,
          "credit_decision_id": data.customer_application.credit_decision_id,
          "is_authenticated": data.customer.is_authenticated,
          "product_type": data.customer_application.product_type,
          "customer_id": data.customer.id
          "customer_application_owner": data.customer_application.application_owner
        }

        if data.config.lead_tracking_url?
          $scope.lead_tracking_url = $sce.trustAsResourceUrl data.config.lead_tracking_url

        $scope.setChatGroup(data.config?.olark.orig)

        # Array of fields that need to be re-entered by customer.
        if data.customer_application.retype_field_section?
          retype_section = data.customer_application.retype_field_section
          $scope.retype_field_section = retype_section

        if data.config && data.config.tm_script_src
          $scope.tm_script_src = $sce.trustAsResourceUrl "#{data.config.tm_script_src}&session_id=#{data.customer_application.uuid}"
          $scope.tm_no_script_src = $sce.trustAsResourceUrl "#{data.config.tm_no_script_src}&session_id=#{data.customer_application.uuid}"
          $scope.tm_on = true
        else
          $scope.tm_on = false
        AvantErrorService.setContext
          user_id: data.customer_application.customer_id
          customer_application: data.customer_application
          variant: data.config.variant.application_view

      angular.extend($scope, data)
      $rootScope.customer = $rootScope.customer || {}
      angular.extend($rootScope.customer, $scope.customer)

      $scope.customer_application.amount_precision = if $scope.customer_application.show_exact_amount then 2 else 0

    $scope.$on "showLoadingMessages", (event, messages) ->
      CustomerApplicationService.showLoadingText(messages)

    $scope.$on "submitDisabled", (event, value) ->
      $scope.submitDisabled = value

    $scope.$on "$routeChangeSuccess", ->
      $scope.contentLoaded = true

    $scope.$on "product:data", (event, data) ->
      $scope.product ||= {}

      if !!$scope.product.payment_method and !data.payment_method
        # temporary fix for customizing product
        angular.extend(data, { payment_method: $scope.product.payment_method})
      angular.extend($scope.product, data)

      # Don't perform rates_terms step calculations unless necessary
      return if data.product_type != 'credit_card' && !data.loans

      if data.product_type != 'credit_card'
        adjustment = 0
        adjustment += $scope.refinance.payoff_amount if $scope.refinance
        adjustment += $scope.customer_application.payoff_amount if $scope.customer_application.auto_refinance
        adjustment += $scope.product.fees if $scope.product.fees

        # REFACTOR FIXME
        # This logic needs to be moved to the server as part of the
        # customer application refactor so we don't duplicate effort
        # across mobile apps, etc
        # DONE: Moved installment calculations into decisioning interface
        # TODO: Move refinance calculations into decisioning interface
        requested_amount = if data.fee_inclusive then data.disbursement_amount else data.amount

        admin_fee_adjust = (amount) ->
          if $scope.customer_application.refinance
            ProductService.roundToNearestCent(amount * (1 - data.administration_fee_rate) - adjustment)
          else
            ProductService.roundToNearestCent(amount - adjustment)

        $scope.product.requested_amount = admin_fee_adjust(requested_amount)
        $scope.product.maximum_requestable_amount = admin_fee_adjust(data.maximum_borrow_amount)
        $scope.product.minimum_requestable_amount = admin_fee_adjust(data.minimum_borrow_amount)
        $scope.display_amount = $scope.product.requested_amount

        if $scope.customer_application.auto_refinance
          $scope.product.minimum_requestable_amount = 0
          $scope.product.requestable_loan_amounts = (amount for amount in [$scope.customer_application.min_cash_out_amount..$scope.customer_application.max_cash_out_amount] by 100)
          $scope.product.requestable_loan_amounts.unshift 0
        else if $scope.customer_application.hard_secured
          $scope.product.requestable_loan_amounts = _.map data.loan_amounts, (amount) -> amount - adjustment
        else if $scope.customer_application.refinance
          if $scope.customer_application.show_exact_amount
            $scope.product.requestable_loan_amounts = _.map data.loan_amounts, (amount) -> admin_fee_adjust(amount)
          else
            minimum = Math.ceil(data.minimum_borrow_amount / 100) * 100
            $scope.product.requestable_loan_amounts = (admin_fee_adjust(amount) for amount in [minimum..data.maximum_borrow_amount] by 100)
        else
          $scope.product.requestable_loan_amounts = data.loan_amounts

        $scope.product.selected_amount_index = _.indexOf $scope.product.requestable_loan_amounts, $scope.product.requested_amount
        # Deprecated variable; provides backward compatibility with older versions
        # of the loan amount slider. $scope.product.requested_amount_index and
        # $scope.product.selected_amount_index should not both be used in the
        # same view.
        $scope.product.requested_amount_index = $scope.product.selected_amount_index

        $scope.maximum_borrow_amount = data.maximum_borrow_amount

        switch $scope.product.product_type
          when "installment"
            gtmProductData = {
              loan_amount:        $scope.product.borrow_amount
              loan_apr:           $scope.product.apr_percentage
              loan_id:            $scope.product.id
              loan_term:          $scope.product.term
            }
            GoogleTagManagerService.extendEventData('legacy', gtmProductData)

            # trigger GTM event (NEW)
            # * notice this is WITHOUT using an eventData namespace, since we have all the data we need for the event right here
            GoogleTagManagerService.fireEvent('product_data_loaded', gtmProductData)

        HeapService.setLoanId $scope.product.id

    $scope.$on "product:updating", (event, data) ->
      $scope.$broadcast "submitDisabled", data
      $scope.updatingProduct = data


    $scope.$on "product:custom_updating", (event, data) ->
      $scope.$broadcast "submitDisabled", data
      $scope.updatingCustom = data

    # For debugging [$rootScope:infdig] related to $locationChangeStart
    $scope.$on '$locationChangeStart', (event, newUrl, oldUrl) ->
      AvantErrorService.appendContext 'locationChangeHistory', { oldUrl: oldUrl, newUrl: newUrl }

    # $scope.$on "customer_application:modal_message", (event, data) ->
    #   CustomerApplicationService.modal_message = data

    $scope.$on 'boolean_gates:data', (event, boolean_gates) ->
      $scope.boolean_gates = boolean_gates

    $scope.isLoan = ->
      ProductService.isLoan()

    $scope.isCreditLine = ->
      ProductService.isCreditLine()

    $scope.isPointOfSale = ->
      ProductService.isPointOfSale()

    $scope.showEditTerm = ->
      ProductService.isLoan() and $scope.product.available_terms.length > 1

    $scope.showEditAmount = ->
      ProductService.isLoan() and $scope.product.minimum_borrow_amount isnt $scope.product.maximum_borrow_amount

    $scope.showEditCreditLimit = ->
      ProductService.isCreditLine() and $scope.product.credit_limit >= $scope.product.minimum_borrow_amount and $scope.product.credit_limit <= $scope.product.maximum_borrow_amount

    $scope.showEditFirstDrawAmount = ->
      ProductService.isCreditLine() and $scope.product.credit_limit >= $scope.product.minimum_borrow_amount and $scope.product.first_draw_amount <= $scope.product.maximum_borrow_amount

    # amountLoadingSpinner directive methods
    $scope.openAmountLoadingSpinner = (config) ->
      $rootScope.$broadcast "amountLoadingSpinner:open", config

    $scope.closeAmountLoadingSpinner = () ->
      $rootScope.$broadcast "amountLoadingSpinner:close"

    # Amount Modal Directive methods
    $scope.openAmountModal = (templateId, config = {}) ->
      $rootScope.$broadcast("amountModal:open", templateId, config)

    $scope.closeAmountModal = () ->
      $rootScope.$broadcast("amountModal:close")

    # Legacy modal instantiation (DEPRECATED in renderer v5+)
    $scope.loadStaticModal = (modalTemplateUrl, modalConfig = {}) ->
      elementInvokingModal = $document.context.activeElement
      modalInstance = $modal.open(
        templateUrl: modalTemplateUrl
        bindToController: true
        controller: [
          "$scope", "$modalInstance", ($scope, $modalInstance) ->
            $scope.modalConfig = modalConfig
            $scope.close = ->
              $modalInstance.close(true)
        ]
      )
      modalInstance.result.then (->
        # dismissed by using the close buttons
        elementInvokingModal?.focus()
      ), ->
        # dismissed modal by esc key or backdrop click
        elementInvokingModal?.focus()

    $scope.$on 'loanAmountUpdatedBySlider', ->
      $scope.loanAmountUpdatedBySlider = true

    $scope.$on 'customer:redirect', (event, location) ->
      $scope.redirecting = true

    $scope.$on 'customer_application:submit', (event, page) ->
      $scope.submittingPage = page

    $scope.$on 'customer_application:app_path', (event, test_var) ->
      if test_var?
        $scope.testB = test_var == 'three_option'

    $scope.updateProductInformation = ->
      if $scope.product? and ($scope.testB? && $scope.testB) and not $scope.product.lock_product_watch
        $scope.product.term = $scope.product.term_int = $scope.product.current_term.months || $scope.product.current_term.term
        $scope.product.monthly_payment = $scope.product.current_term.monthly_payment
        true

    $scope.select_loan = (loan, options = {}) ->
      $scope.show_custom = loan=="other"
      if loan == "other"
        $scope.product.selected_loan = $scope.product.custom_quote
        $scope.product.selected_loan.apr = $scope.product.custom_quote.apr
        $scope.product.amount_cents = parseInt($scope.product.amount, 10) * 100
        $scope.product.current_term = $scope.product.custom_quote.available_terms[0]
      else
        $scope.product.selected_loan = loan
        $scope.product.current_term = $scope.product.selected_loan
      $scope.product.amount = $scope.product.borrow_amount = $scope.product.selected_loan.borrow_amount || $scope.product.minimum_borrow_amount
      $scope.product.borrow_apr = $scope.product.selected_loan.apr
      $scope.updateProductInformation()

    $scope.updateCreditLine = ->
      return if $scope.submittingPage?
      $scope.$broadcast "contract:clear"
      params =
        borrow_amount: $scope.product.borrow_amount
        first_draw_amount: $scope.product.first_draw_amount
      ProductService.update(ApplicationService.target_application_id(), params)

    $scope.currentlySelectedAmount = ->
      if $scope.product.requestable_loan_amounts
        $scope.product.requestable_loan_amounts[$scope.product.selected_amount_index]
      else
        null

    $scope.selectedAmountHasChanged = ->
      $scope.currentlySelectedAmount() != $scope.product.requested_amount

    isValidRequestableAmountIndex = (index) ->
      index >= 0 && index < $scope.product.requestable_loan_amounts.length

    closestRequestableAmountIndex = (index) ->
      if index < 0
        0
      else if index >= $scope.product.requestable_loan_amounts.length
        $scope.product.requestable_loan_amounts.length - 1
      else
        index

    changeSelectedAmountIndex = (difference) ->
      new_selected_amount_index = $scope.product.selected_amount_index + difference
      if isValidRequestableAmountIndex(new_selected_amount_index)
        $scope.product.selected_amount_index = new_selected_amount_index
      else
        $scope.product.selected_amount_index = closestRequestableAmountIndex(new_selected_amount_index)
        $scope.stopChangingSelectedAmount()

    $scope.beginChangingSelectedAmount = (placesToIncrement) ->
      # Interval should already be stopped, but in case a bug caused it to
      # to persist, we must cancel it
      $scope.stopChangingSelectedAmount()
      changeSelectedAmountIndex(placesToIncrement)
      $scope.amountChangeInterval = $interval(
        () -> changeSelectedAmountIndex(placesToIncrement),
        AMOUNT_CHANGE_INTERVAL_TIME
      )

    $scope.stopChangingSelectedAmount = ->
      $interval.cancel($scope.amountChangeInterval)

    # beginChangingRequestedAmount() and stopChangingRequestedAmount() are
    # deprecated methods included for backward compatibility
    $scope.beginChangingRequestedAmount = (amountToIncrement) ->
      placesToIncrement = if amountToIncrement > 0 then 1 else -1
      $scope.beginChangingSelectedAmount(placesToIncrement)

    $scope.stopChangingRequestedAmount = -> $scope.stopChangingSelectedAmount()

    $scope.$on('$destroy', () -> stopChangingSelectedAmount())

    $scope.updateProductAmount = _.debounce((new_requested_amount) ->
      $scope.requested_amount = new_requested_amount
      $scope.$broadcast "requested_amount_changed", new_requested_amount
      borrow_amount = new_requested_amount
      borrow_amount += $scope.refinance.payoff_amount if $scope.customer_application.refinance
      borrow_amount += $scope.customer_application.payoff_amount if $scope.customer_application.auto_refinance
      borrow_amount += $scope.product.fees if $scope.product.fees
      if $scope.customer_application.refinance
        if $scope.customer_application.show_exact_amount
          borrow_amount = ProductService.roundToNearestCent(borrow_amount / (1 - $scope.product.administration_fee_rate))
        else
          borrow_amount = Math.round(borrow_amount / (1 - $scope.product.administration_fee_rate))

      $scope.updateAmount(borrow_amount)
    , 200)

    $scope.clearSelectedLoan = ->
      $scope.product?.selected_loan = null

    $scope.updateAmount = (amount) ->
      $scope.product?.loans = []
      # need to return a promise here
      deferred = $q.defer()
      unless $scope.submittingPage?
        $scope.clearSelectedLoan()
        ProductService.update(ApplicationService.target_application_id(), { borrow_amount: amount }).then ->
          amount = ProductService.getBorrowAmount()
          deferred.resolve()
          if $scope.loanAmountUpdatedBySlider
            $rootScope.$broadcast 'focusLoanAmountSlider'
          else
            $rootScope.$broadcast 'focusLoanAmountTextInput'
      deferred.promise

    $scope.quietUpdate = ->
      # need to return a promise here
      deferred = $q.defer()
      unless $scope.submittingPage?
        $scope.clearSelectedLoan()
        amount = if $scope.customer_application.refinance then $scope.product.amount else $scope.product.requested_amount
        ProductService.silentUpdate(ApplicationService.data.customer_application.id,
          borrow_amount: amount,
          term: parseInt($scope.product.term, 10),
          rate_option_id: $scope.selected_rate_option_id()
        ).then ->
          deferred.resolve()
      deferred.promise

    $scope.selected_rate_option_id = ->
      $scope.product && $scope.product.current_term && $scope.product.current_term.rate_option_id


    $scope.raceValues = [
      'American Indian or Alaska Native',
      'Asian',
      'Black or African American',
      'Native Hawaiian or Other Pacific Islander',
      'White',
      'I do not wish to furnish this information'
    ]

    $scope.selectedRaceValues = []

    $scope.toggleSelectedRaceValues = (raceName) ->
      idx = $scope.selectedRaceValues.indexOf(raceName)
      if idx > -1
        $scope.selectedRaceValues.splice idx, 1
      else
        $scope.selectedRaceValues.push raceName

      beforeValue = $scope.customer_application_metadata.home_improvement_race
      $scope.customer_application_metadata.home_improvement_race = $scope.mapRaceToNumber($scope.selectedRaceValues).sort().filter(Number)
      # Set $dirty to be true
      viewValue = this.form.customer_application_metadata_home_improvement_race.$viewValue
      if !viewValue || viewValue.length == 0
        viewValue = $scope.customer_application_metadata.home_improvement_race
      if beforeValue && beforeValue.length > 0
        this.form.customer_application_metadata_home_improvement_race.$setViewValue(viewValue)

      if $scope.selectedRaceValues.includes($scope.raceValues[5]) && $scope.selectedRaceValues.length > 1
        if $scope.raceValues[5] != raceName && $scope.selectedRaceValues.includes($scope.raceValues[5])
          idx = $scope.selectedRaceValues.indexOf($scope.raceValues[5])
          $scope.selectedRaceValues.splice idx, 1
        else
          $scope.selectedRaceValues = [$scope.raceValues[5]]
          $scope.customer_application_metadata.home_improvement_race = [6]

      return

    $scope.mapRaceToNumber = (races) ->
      races.map (race) ->
        switch race
          when $scope.raceValues[0]
            1
          when $scope.raceValues[1]
            2
          when $scope.raceValues[2]
            3
          when $scope.raceValues[3]
            4
          when $scope.raceValues[4]
            5
          when $scope.raceValues[5]
            6

    $scope.updateProductTerm = ->
      return if $scope.submittingPage?
      @oldTerm = parseInt($scope.product.term, 10)
      ProductService.update(ApplicationService.target_application_id(), { term: $scope.product.term }).then (product) ->
        # ridiculous hack for select box
        # caused because of async nature of term / available terms
        term = $scope.product.term
        $scope.product.term = "0"
        if !$scope.$$phase
          $scope.$apply()
        $scope.product.term = term

    $scope.leadWelcomeModalLogo = {
      '9global': require("@amount/frontend-styles/src/images/logo/partner-logos/9global.jpg"),
      'ahl_post': require("@amount/frontend-styles/src/images/logo/partner-logos/ahl_post.jpg"),
      'am_one_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/am_one_prefill.jpg"),
      'aspire': require("@amount/frontend-styles/src/images/logo/partner-logos/aspire.jpg"),
      'aspire_multioption': require("@amount/frontend-styles/src/images/logo/partner-logos/aspire_multioption.jpg"),
      'bankrate_avant_post': require("@amount/frontend-styles/src/images/logo/partner-logos/bankrate_avant_post.jpg"),
      'bankrate_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/bankrate_prefill.jpg"),
      'cashadvance': require("@amount/frontend-styles/src/images/logo/partner-logos/cashadvance.jpg"),
      'cheerlending': require("@amount/frontend-styles/src/images/logo/partner-logos/cheerlending.jpg"),
      'clearscore': require("@amount/frontend-styles/src/images/logo/partner-logos/clearscore.jpg"),
      'clearscore_multioption': require("@amount/frontend-styles/src/images/logo/partner-logos/clearscore_multioption.jpg"),
      'clickfinancial': require("@amount/frontend-styles/src/images/logo/partner-logos/clickfinancial.jpg"),
      'clickfinancial_multioption': require("@amount/frontend-styles/src/images/logo/partner-logos/clickfinancial_multioption.jpg"),
      'confused': require("@amount/frontend-styles/src/images/logo/partner-logos/confused.jpg"),
      'credit_karma': require("@amount/frontend-styles/src/images/logo/partner-logos/credit_karma.jpg"),
      'credit_karma_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/credit_karma_prefill.jpg"),
      'credit_sesame_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/credit_sesame_prefill.jpg"),
      'creditiq': require("@amount/frontend-styles/src/images/logo/partner-logos/creditiq.jpg"),
      'crowdnetic': require("@amount/frontend-styles/src/images/logo/partner-logos/crowdnetic.jpg"),
      'crowdnetic_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/crowdnetic_prefill.jpg"),
      'green_dot_money_async': require("@amount/frontend-styles/src/images/logo/partner-logos/green_dot_money_async.jpg"),
      'jgwentworth': require("@amount/frontend-styles/src/images/logo/partner-logos/jgwentworth.jpg"),
      'leadsgroup': require("@amount/frontend-styles/src/images/logo/partner-logos/leadsgroup.jpg"),
      'lending_tree': require("@amount/frontend-styles/src/images/logo/partner-logos/lending_tree.jpg"),
      'loan_depot_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/loan_depot_prefill.jpg"),
      'loans_canada': require("@amount/frontend-styles/src/images/logo/partner-logos/loans_canada.jpg"),
      'loanswarehouse': require("@amount/frontend-styles/src/images/logo/partner-logos/loanswarehouse.jpg"),
      'loanswarehouse_multioption': require("@amount/frontend-styles/src/images/logo/partner-logos/loanswarehouse_multioption.jpg"),
      'loanus_post': require("@amount/frontend-styles/src/images/logo/partner-logos/loanus_post.jpg"),
      'lowermybills': require("@amount/frontend-styles/src/images/logo/partner-logos/lowermybills.jpg"),
      'luav_post': require("@amount/frontend-styles/src/images/logo/partner-logos/luav_post.jpg"),
      'magnifymoney': require("@amount/frontend-styles/src/images/logo/partner-logos/magnifymoney.jpg"),
      'magnifymoney_post': require("@amount/frontend-styles/src/images/logo/partner-logos/magnifymoney_post.jpg"),
      'moneysupermarket': require("@amount/frontend-styles/src/images/logo/partner-logos/moneysupermarket.jpg"),
      'mybankrate_post': require("@amount/frontend-styles/src/images/logo/partner-logos/mybankrate_post.jpg"),
      'mybankrate_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/mybankrate_prefill.jpg"),
      'nerd_wallet_post': require("@amount/frontend-styles/src/images/logo/partner-logos/nerd_wallet_post.jpg"),
      'nerd_wallet_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/nerd_wallet_prefill.jpg"),
      'payzer': require("@amount/frontend-styles/src/images/logo/partner-logos/payzer.jpg"),
      'personalloanscom': require("@amount/frontend-styles/src/images/logo/partner-logos/personalloanscom.jpg"),
      'progressus_post': require("@amount/frontend-styles/src/images/logo/partner-logos/progressus_post.jpg"),
      'quinstreet': require("@amount/frontend-styles/src/images/logo/partner-logos/quinstreet.jpg"),
      'quizzle_post': require("@amount/frontend-styles/src/images/logo/partner-logos/quizzle_post.jpg"),
      'quizzle_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/quizzle_prefill.jpg"),
      'solutionloans': require("@amount/frontend-styles/src/images/logo/partner-logos/solutionloans.jpg"),
      'solutionloans_multioption': require("@amount/frontend-styles/src/images/logo/partner-logos/solutionloans_multioption.jpg"),
      'stairway_post': require("@amount/frontend-styles/src/images/logo/partner-logos/stairway_post.jpg"),
      'unsecuredloans': require("@amount/frontend-styles/src/images/logo/partner-logos/unsecuredloans.jpg"),
      'uplift2': require("@amount/frontend-styles/src/images/logo/partner-logos/uplift2.jpg")
    };
    $scope.leadWelcomeModalLogo2x = {
      '9global': require("@amount/frontend-styles/src/images/logo/partner-logos/9global@2x.jpg"),
      'ahl_post': require("@amount/frontend-styles/src/images/logo/partner-logos/ahl_post@2x.jpg"),
      'am_one_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/am_one_prefill@2x.jpg"),
      'aspire': require("@amount/frontend-styles/src/images/logo/partner-logos/aspire@2x.jpg"),
      'aspire_multioption': require("@amount/frontend-styles/src/images/logo/partner-logos/aspire_multioption@2x.jpg"),
      'bankrate_avant_post': require("@amount/frontend-styles/src/images/logo/partner-logos/bankrate_avant_post@2x.jpg"),
      'bankrate_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/bankrate_prefill@2x.jpg"),
      'cashadvance': require("@amount/frontend-styles/src/images/logo/partner-logos/cashadvance@2x.jpg"),
      'cheerlending': require("@amount/frontend-styles/src/images/logo/partner-logos/cheerlending@2x.jpg"),
      'clearscore': require("@amount/frontend-styles/src/images/logo/partner-logos/clearscore@2x.jpg"),
      'clearscore_multioption': require("@amount/frontend-styles/src/images/logo/partner-logos/clearscore_multioption@2x.jpg"),
      'clickfinancial': require("@amount/frontend-styles/src/images/logo/partner-logos/clickfinancial@2x.jpg"),
      'confused': require("@amount/frontend-styles/src/images/logo/partner-logos/confused@2x.jpg"),
      'credit_karma': require("@amount/frontend-styles/src/images/logo/partner-logos/credit_karma@2x.jpg"),
      'credit_karma_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/credit_karma_prefill@2x.jpg"),
      'clickfinancial_multioption': require("@amount/frontend-styles/src/images/logo/partner-logos/clickfinancial_multioption@2x.jpg"),
      'credit_sesame_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/credit_sesame_prefill@2x.jpg"),
      'creditiq': require("@amount/frontend-styles/src/images/logo/partner-logos/creditiq@2x.jpg"),
      'crowdnetic': require("@amount/frontend-styles/src/images/logo/partner-logos/crowdnetic@2x.jpg"),
      'crowdnetic_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/crowdnetic_prefill@2x.jpg"),
      'green_dot_money_async': require("@amount/frontend-styles/src/images/logo/partner-logos/green_dot_money_async@2x.jpg"),
      'jgwentworth': require("@amount/frontend-styles/src/images/logo/partner-logos/jgwentworth@2x.jpg"),
      'leadsgroup': require("@amount/frontend-styles/src/images/logo/partner-logos/leadsgroup@2x.jpg"),
      'lending_tree': require("@amount/frontend-styles/src/images/logo/partner-logos/lending_tree@2x.jpg"),
      'loan_depot_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/loan_depot_prefill@2x.jpg"),
      'loans_canada': require("@amount/frontend-styles/src/images/logo/partner-logos/loans_canada@2x.jpg"),
      'loanswarehouse': require("@amount/frontend-styles/src/images/logo/partner-logos/loanswarehouse@2x.jpg"),
      'loanswarehouse_multioption': require("@amount/frontend-styles/src/images/logo/partner-logos/loanswarehouse_multioption@2x.jpg"),
      'loanus_post': require("@amount/frontend-styles/src/images/logo/partner-logos/loanus_post@2x.jpg"),
      'lowermybills': require("@amount/frontend-styles/src/images/logo/partner-logos/lowermybills@2x.jpg"),
      'luav_post': require("@amount/frontend-styles/src/images/logo/partner-logos/luav_post@2x.jpg"),
      'magnifymoney': require("@amount/frontend-styles/src/images/logo/partner-logos/magnifymoney@2x.jpg"),
      'magnifymoney_post': require("@amount/frontend-styles/src/images/logo/partner-logos/magnifymoney_post@2x.jpg"),
      'moneysupermarket': require("@amount/frontend-styles/src/images/logo/partner-logos/moneysupermarket@2x.jpg"),
      'mybankrate_post': require("@amount/frontend-styles/src/images/logo/partner-logos/mybankrate_post@2x.jpg"),
      'mybankrate_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/mybankrate_prefill@2x.jpg"),
      'nerd_wallet_post': require("@amount/frontend-styles/src/images/logo/partner-logos/nerd_wallet_post@2x.jpg"),
      'nerd_wallet_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/nerd_wallet_prefill@2x.jpg"),
      'payzer': require("@amount/frontend-styles/src/images/logo/partner-logos/payzer@2x.jpg"),
      'personalloanscom': require("@amount/frontend-styles/src/images/logo/partner-logos/personalloanscom@2x.jpg"),
      'progressus_post': require("@amount/frontend-styles/src/images/logo/partner-logos/progressus_post@2x.jpg"),
      'quinstreet': require("@amount/frontend-styles/src/images/logo/partner-logos/quinstreet@2x.jpg"),
      'quizzle_post': require("@amount/frontend-styles/src/images/logo/partner-logos/quizzle_post@2x.jpg"),
      'quizzle_prefill': require("@amount/frontend-styles/src/images/logo/partner-logos/quizzle_prefill@2x.jpg"),
      'solutionloans': require("@amount/frontend-styles/src/images/logo/partner-logos/solutionloans@2x.jpg"),
      'solutionloans_multioption': require("@amount/frontend-styles/src/images/logo/partner-logos/solutionloans_multioption@2x.jpg"),
      'stairway_post': require("@amount/frontend-styles/src/images/logo/partner-logos/stairway_post@2x.jpg"),
      'unsecuredloans': require("@amount/frontend-styles/src/images/logo/partner-logos/unsecuredloans@2x.jpg"),
    }
]
